module.exports = __webpack_public_path__ + "img/1477726621.9ca58fde.jpg";